
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class CsVatCodeDialog extends Serenity.EntityDialog<CsVatCodeRow, any> {
        protected getFormKey() { return CsVatCodeForm.formKey; }
        protected getIdProperty() { return CsVatCodeRow.idProperty; }
        protected getLocalTextPrefix() { return CsVatCodeRow.localTextPrefix; }
        protected getNameProperty() { return CsVatCodeRow.nameProperty; }
        protected getService() { return CsVatCodeService.baseUrl; }
        protected getDeletePermission() { return CsVatCodeRow.deletePermission; }
        protected getInsertPermission() { return CsVatCodeRow.insertPermission; }
        protected getUpdatePermission() { return CsVatCodeRow.updatePermission; }

        protected form = new CsVatCodeForm(this.idPrefix);

        protected afterLoadEntity() {
            super.afterLoadEntity();

            var Vatcode = Q.tryFirst(Product.CsSkuRow.getLookup().items,x => x.VatCode == this.entity.VatCode)
            if(Vatcode !=null){
                this.deleteButton.toggleClass('disabled', true);
                
            }

            if(this.form.VatCode.value == 'N')
                this.deleteButton.toggleClass('disabled', true);
        }
        
    }
}